<template>
  <div class="bookshelf-edit-transfer">
    <div class="bookshelf-xtransfer-content">
      <div class="xtransfer-left">
        <div class="xtransfer-header">{{ `待选书刊专辑（${sourceData.length}）` }}</div>
        <div class="xtransfer-main">
          <div class="xtransfer-tabs">
            <div v-for="(item, index) in typeList" :key="index" :class="{ active: leftCurrentType === item.type }" @click="clickChangeType(item)">{{ item.name }}</div>
          </div>
          <div class="xtransfer-input">
            <el-input v-model="leftInput" placeholder="请输入书名搜索"></el-input>
            <label @click="clickSearch('left')">搜索</label>
          </div>
          <ul class="xtransfer-list" v-show="!leftHasNoMatch && leftRenderData.length > 0">
            <li v-for="item in leftRenderData.slice(10 * (leftCurrentPage - 1), leftCurrentPage * 10)" :key="item.id">
              <el-checkbox :title="item.name || item.title" v-model="item.checked" @change="checkboxChange(item.id, 'left', $event)">{{ item.name || item.title }}</el-checkbox>
              <div class="item-info-time">{{ item.time }}</div>
              <div class="item-info-icon info-icon-view">
                <img src="@imgs/bookshelfedit/icon_view.png" title="查看作品" alt="" @click="goDetail(item.id, item.readModel, item.url)" />
              </div>
            </li>
          </ul>
          <div class="xtransfer-nomatch" v-show="leftHasNoMatch">无匹配数据</div>
          <div class="xtransfer-nomatch" v-show="leftRenderData.length === 0 && !leftHasNoMatch">{{ noDataDes }}</div>
          <elPagination1
            ref="leftPagination"
            :layout="'prev, pager, next'"
            :total="leftTotalCount"
            :pageSize="leftPageSize"
            :pageCount="5"
            :small="true"
            :currentPage="leftCurrentPage"
            @handleCurrentChange="handleCurrentChange('left', $event)"
            @handleSizeChange="handleSizeChange('left', $event)"
          ></elPagination1>
        </div>
      </div>
      <div class="xtransfer-btn-group">
        <div class="xtransfer-btn xtransfer-btn-torightall" @click="clickToRight('all')"></div>
        <div class="xtransfer-btn xtransfer-btn-toright" @click="clickToRight('some')"></div>
        <div class=" xtransfer-btn xtransfer-btn-toleft" @click="clickToLeft('some')"></div>
        <div class="xtransfer-btn xtransfer-btn-toleftall" @click="clickToLeft('all')"></div>
      </div>
      <div class="xtransfer-right">
        <div class="xtransfer-header">{{ `已选书刊专辑（${targetData.length}）` }}</div>
        <div class="xtransfer-main">
          <div class="xtransfer-input">
            <el-input v-model="rightInput" placeholder="请输入书名搜索"></el-input>
            <label @click="clickSearch('right')">搜索</label>
          </div>
          <ul class="xtransfer-list" v-show="!rightHasNoMatch && targetData.length > 0">
            <li style="position: relative" v-for="item in rightFilteredData.slice(10 * (rightCurrentPage - 1), rightCurrentPage * 10)" :key="item.id">
              <el-checkbox :title="item.name || item.title" v-model="item.checked" @change="checkboxChange(item.id, 'right', $event)">
                <img class="item-info-icon-line" src="@imgs/bookshelfedit/link.png" v-if="item.type == 'linkWork'" alt="" @click="goLinkUrl(item)" />
                {{ item.name || item.title }}
              </el-checkbox>
              <div class="item-info-time">{{ item.time }}</div>

              <div class="item-info-icon info-icon-view">
                <img src="@imgs/bookshelfedit/icon_view.png" title="查看作品" @click="goDetail(item.id, item.readModel, item.url)" />
              </div>
              <div class="item-info-icon info-icon-up">
                <img src="@imgs/bookshelfedit/MoveTop@2x.png" title="置顶" @click="clickTopUp(item.id)" alt="" />
              </div>
              <div class="item-info-icon info-icon-up">
                <img src="@imgs/bookshelfedit/icon_up.png" title="上移" @click="clickUp(item.id)" alt="" />
              </div>
              <div class="item-info-icon info-icon-down">
                <img src="@imgs/bookshelfedit/icon_down.png" title="下移" @click="clickDown(item.id)" alt="" />
              </div>
              <div class="item-info-icon info-icon-up">
                <img src="@imgs/bookshelfedit/MoveBottom@2x.png" title="置底" @click="clickBottomDown(item.id)" alt="" />
              </div>
            </li>
          </ul>
          <div class="xtransfer-nomatch" v-show="rightHasNoMatch">无匹配数据</div>
          <div class="xtransfer-nomatch" v-show="targetData.length === 0 && !rightHasNoMatch">{{ noDataDes }}</div>
          <elPagination1
            ref="rightPagination"
            :layout="'prev, pager, next'"
            :total="rightTotalCount"
            :pageSize="rightPageSize"
            :pageCount="5"
            :small="true"
            :currentPage="rightCurrentPage"
            @handleCurrentChange="handleCurrentChange('right', $event)"
          ></elPagination1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import elPagination1 from '@components/common/elPagination.vue'
import bookLib from '@api/bookLib'
import moment from 'moment'
import BookShelfInterface from '@api/BookShelf'
import APILinkWork from '@api/LinkPubilshen'
import apis from '@api/getBook'
import { setEncryption } from '@/utils'
export default {
  name: 'BookLibEdit',
  data() {
    return {
      msg: '书架编辑页',
      noDataDes: '无数据',
      typeList: [
        {
          name: '书刊',
          type: 'book'
        },
        {
          name: '专辑',
          type: 'album'
        },
        {
          name: '链接作品',
          type: 'linkWork'
        }
      ],
      leftCurrentType: 'book',
      leftInput: '',
      leftSearch: '',
      leftPageSize: 10,
      leftCurrentPage: 1,
      rightInput: '',
      rightSearch: '',
      rightPageSize: 10,
      rightCurrentPage: 1,
      props: {
        label: 'title',
        name: 'name',
        key: 'id'
      },
      targetOrder: 'unshift',
      leftChecked: [],
      rightChecked: [],
      checkChangeByUser: true,
      bookAllList: [], //从接口请求来所有书刊数据
      linkWorkAllList: [],
      bookShelfAllList: [], //从接口请求来所有专辑数据
      allList: [], //从接口请求来所有书刊专辑数据
      newValue: [], //已选书刊专辑id
      totalCount: null,
      getAlreadyStatus: false
    }
  },
  watch: {
    leftInput(val) {
      if (!val) {
        this.clickSearch('left')
      }
    },
    rightInput(val) {
      if (!val) {
        this.clickSearch('right')
      }
    },
    targetData(val) {
      if (val && val.length == 0) {
        this.$store.commit('config/UPDATE_BOOKSLIB_IDS', [])
      }
    },
    stateBookIds(val) {
      if (this.getAlreadyStatus && val.length > 0) {
        this.$emit('getSeaveButton', false)
        this.getAlreadyStatus = true
      }
    }
  },
  computed: {
    stateBookIds() {
      return this.$store.state.config.bookLibObj.ids
    },
    userName() {
      return localStorage.getItem('username')
    },
    libId() {
      return window.sessionStorage.getItem('libId')
    },
    data() {
      return this.$store.state.config.bookLibObj.allBookList
    },
    value: {
      get() {
        return this.$store.state.config.bookLibObj.chooseBookList
      },
      set(value) {
        this.$store.commit('config/UPDATE_BOOKLIBTITLE_CHOSEBOOKLIST', JSON.parse(JSON.stringify(value)))
      }
    },
    leftTotalCount() {
      return this.leftRenderData.length
    },
    rightTotalCount() {
      return this.rightFilteredData.length
    },
    leftHasNoMatch() {
      return this.leftSearch.length > 0 && this.leftRenderData.length === 0
    },
    rightHasNoMatch() {
      return this.rightSearch.length > 0 && this.rightFilteredData.length === 0
    },
    leftRenderData() {
      // 左侧穿梭框书刊或者专辑数据
      // 根据页签是书刊还是专辑过滤左侧穿梭框数据
      return this.leftFilteredData.filter((item) => {
        return item.type == this.leftCurrentType
      })
    },
    leftFilteredData() {
      // 左侧穿梭框数据中满足input筛选条件的数据
      // 筛选条件是空值，则筛选出来的是所有数据
      let that = this
      console.log(that.sourceData)
      console.log(that.filterMethod)
      return that.sourceData.filter((item) => {
        if (typeof that.filterMethod === 'function') {
          return that.filterMethod(that.leftSearch, item)
        } else {
          const label = item[that.props.label] || item[that.props.name]
          if (label) {
            return label.toLowerCase().indexOf(that.leftSearch.toLowerCase()) > -1
          }
        }
      })
    },
    rightFilteredData() {
      let that = this
      return that.targetData.filter((item) => {
        if (typeof that.filterMethod === 'function') {
          return that.filterMethod(that.rightSearch, item)
        } else {
          const label = item[that.props.label] || item[that.props.name]
          if (label) {
            return label.toLowerCase().indexOf(this.rightSearch.toLowerCase()) > -1
          }
        }
      })
    },
    dataObj() {
      const key = this.props.key
      // 用于 targetData 中push
      // 返回一个对象
      // 该对象的键为原始所有数据的每一个id（this.props.key）
      // 值为该id（this.props.key）在原始所有数据中对应的数据
      return this.data.reduce((o, cur) => (o[cur[key]] = cur) && o, {})
    },
    sourceData() {
      // 左侧穿梭框的数据
      // 从原始数据中过滤掉右侧穿梭框的数据
      // this.value 存储的是右侧穿梭框的数据标识
      return this.data.filter((item) => this.value.indexOf(item[this.props.key]) === -1)
    },
    targetData() {
      // 右侧穿梭框数据
      if (this.targetOrder === 'original') {
        // 数据按在原始数据的顺序进行排序
        return this.data.filter((item) => this.value.indexOf(item[this.props.key]) > -1)
      } else {
        // 新加入的元素排在最后
        return this.value.reduce((arr, cur) => {
          const val = this.dataObj[cur]
          if (val) {
            arr.push(val)
          }
          this.$store.commit('config/UPDATE_BOOKSLIB_IDS', this.value)
          return arr
        }, [])
      }
    }
  },
  components: {
    elPagination1
  },
  mounted() {
    this.bookLibAlready(1)
    this.getBookAllList(1)
  },
  methods: {
    // 已选书刊专辑列表
    bookLibAlready(No) {
      let params = {
        pageNo: No,
        pageSize: 10,
        libraryId: this.libId,
        name: ''
      }
      var that = this
      let value = [] //已选书刊专辑id组成的数组
      bookLib.bookLibAlready(params).then((res) => {
        if (res && res.status == 200) {
          res.data.page.result.forEach((item) => {
            value.push(item.id)
          })
          that.newValue = this.newValue.concat(value)
          if (res.data.page.totalCount > params.pageNo * params.pageSize) {
            params.pageNo++
            that.bookLibAlready(params.pageNo)
          } else {
            // 数据加载完成保存按钮可用
            this.$store.commit('config/UPDATE_BOOKLIBTITLE_CHOSEBOOKLIST', JSON.parse(JSON.stringify(this.newValue)))
            if (this.newValue.length > 0) {
              this.getAlreadyStatus = true
            } else {
              this.$emit('getSeaveButton', false)
            }
          }
        }
      })
    },
    // 获取电子书列表分页时调用的
    getBookAllList(No) {
      let param = {
        pageNo: No,
        pageSize: 10
      }
      let that = this
      let bookAllList = []
      apis.GetEbookByPage(param).then((res) => {
        if (res && res.status == 200 && res.data.page) {
          if (res.data.page.result.length) {
            bookAllList = res.data.page.result.map((item, index) => {
              return {
                ...item,
                checked: false,
                id: 'ebook' + item.id,
                type: 'book',
                time: moment(item.createTime).format('YYYY-MM-DD HH:mm')
              }
            })
            that.totalCount = res.data.page.totalCount
            that.bookAllList = that.bookAllList.concat(bookAllList)
            if (res.data.page.totalCount > param.pageNo * param.pageSize) {
              param.pageNo++
              that.getBookAllList(param.pageNo)
            } else {
              that.getAllLinkWork(1)
            }
          }
        } else {
          that.getAllLinkWork(1)
        }
      })
    },
    // 返回全部链接作品
    getAllLinkWork(pageNo) {
      let param = {
        pageNo: pageNo,
        pageSize: 10,
        username: this.userName
      }
      let that = this
      let linkWorkAllList = []
      APILinkWork.getLinkWorks(param).then((res) => {
        if (res && res.data) {
          if (res.data.page.result.length) {
            linkWorkAllList = res.data.page.result.map((item, index) => {
              return {
                ...item,
                checked: false,
                id: 'ebook' + item.id,
                type: 'linkWork',
                time: moment(item.createTime).format('YYYY-MM-DD HH:mm')
              }
            })
            that.totalCount = res.data.page.totalCount
            that.linkWorkAllList = that.linkWorkAllList.concat(linkWorkAllList)
            if (res.data.page.totalCount > param.pageNo * param.pageSize) {
              param.pageNo++
              that.getAllLinkWork(param.pageNo)
            } else {
              that.getBookShelfList(1)
            }
          } else {
            that.getBookShelfList(1)
          }
        }
      })
    },
    // 返回所有专辑数据
    getBookShelfList(pageNo) {
      let param = {
        pageNo: pageNo,
        pageSize: 10,
        username: this.userName
      }
      let bookShelfAllList = []
      BookShelfInterface.getBookShelfList(param).then((res) => {
        if (res && res.status == 200 && res.data.page) {
          if (res.data.page.result.length) {
            bookShelfAllList = res.data.page.result.map((item, index) => {
              return {
                ...item,
                checked: false,
                id: 'album' + item.id,
                type: 'album',
                time: moment(item.createTime).format('YYYY-MM-DD HH:mm')
              }
            })
            this.bookShelfAllList = this.bookShelfAllList.concat(bookShelfAllList)
            if (res.data.page.totalCount > param.pageNo * param.pageSize) {
              param.pageNo++
              this.getBookShelfList(param.pageNo)
            } else {
              this.concatWorks()
            }
          } else {
            this.concatWorks()
          }
          if (this.allList && this.allList.length === 0) {
            this.noDataDes = '无数据'
          }
        } else {
          this.concatWorks()
        }
      })
    },
    concatWorks() {
      if (this.bookAllList.length !== 0 && this.linkWorkAllList.length !== 0) {
        let a = this.bookAllList.concat(this.linkWorkAllList)
        this.allList = a.concat(this.bookShelfAllList)
      } else if (this.bookAllList.length !== 0) {
        this.allList = this.bookAllList.concat(this.bookShelfAllList)
      } else if (this.linkWorkAllList.length !== 0) {
        this.allList = this.linkWorkAllList.concat(this.bookShelfAllList)
      }

      const removeDuplicateObj = (arr) => {
        let obj = {}
        arr = arr.reduce((newArr, next) => {
          obj[next.id] ? '' : (obj[next.id] = true && newArr.push(next))
          return newArr
        }, [])
        return arr
      }
      let list = removeDuplicateObj(this.allList)
      this.$store.commit('config/UPDATE_BOOKLIBTITLE_ALLBOOKLIST', JSON.parse(JSON.stringify(list)))
    },
    clickChangeType(item) {
      this.leftInput = ''
      this.leftCurrentPage = 1
      this.leftCurrentType = item.type
    },
    goLinkUrl(item) {
      window.open(item.url, '_blank')
      console.log(item.url)
    },
    clickTopUp(id) {
      let filterIndex
      this.rightFilteredData.some((item, itemIndex) => {
        if (item.id === id) {
          filterIndex = itemIndex
          return true
        }
      })
      if (filterIndex === 0) {
        this.$message({
          type: 'error',
          message: '第一条数据已置顶'
        })
      } else {
        // 第一条数据的的id
        let prevId = this.rightFilteredData[0].id
        // 前一条数据在 this.value 中的位置
        let prevIndex = this.value.indexOf(prevId)
        // 当前需要置顶的id
        let currentId = id
        // 当前需要置顶的数据在 this.value 中的位置
        let currentIndex = this.value.indexOf(currentId)
        // 交换两条数剧的位置

        let leftList = []
        this.value.forEach((item, i) => {
          if (item !== currentId) {
            leftList.push(item)
          }
        })
        leftList.unshift(currentId)
        this.value = leftList
        // this.$set(this.value, prevIndex, currentId)
        // this.$set(this.value, currentIndex, prevId)
      }
    },

    // 右侧穿梭框数据上移
    clickUp(id) {
      let filterIndex
      this.rightFilteredData.some((item, itemIndex) => {
        if (item.id === id) {
          filterIndex = itemIndex
          return true
        }
      })
      if (filterIndex === 0) {
        this.$message({
          type: 'error',
          message: '第一条数据, 不能上移'
        })
      } else {
        // 前一条数据的的id
        let prevId = this.rightFilteredData[filterIndex - 1].id
        // 前一条数据在 this.value 中的位置
        let prevIndex = this.value.indexOf(prevId)
        // 当前需要上移的id
        let currentId = id
        // 当前需要上移的数据在 this.value 中的位置
        let currentIndex = this.value.indexOf(currentId)
        // 交换两条数剧的位置
        this.$set(this.value, prevIndex, currentId)
        this.$set(this.value, currentIndex, prevId)
        // 移动数据位于该页第一条，则上移之后，跳转至前一页
        if (filterIndex % 10 === 0) {
          this.rightCurrentPage = filterIndex / 10
        }
      }
    },
    clickBottomDown(id) {
      let filterIndex
      this.rightFilteredData.some((item, itemIndex) => {
        if (item.id === id) {
          filterIndex = itemIndex
          return true
        }
      })
      if (filterIndex === this.rightFilteredData.length - 1) {
        this.$message({
          type: 'error',
          message: '最后一条数据已置底'
        })
      } else {
        // 第一条数据的的id
        let prevId = this.rightFilteredData[this.rightFilteredData.length - 1].id
        // 前一条数据在 this.value 中的位置
        let prevIndex = this.value.indexOf(prevId)
        // 当前需要置的id
        let currentId = id
        // 当前需要置顶的数据在 this.value 中的位置
        let currentIndex = this.value.indexOf(currentId)
        // 交换两条数剧的位置

        let leftList = []
        this.value.forEach((item, i) => {
          if (item !== currentId) {
            leftList.push(item)
          }
        })
        leftList.push(currentId)
        this.value = leftList

        //       this.$set(this.value, prevIndex, currentId)
        //       this.$set(this.value, currentIndex, prevId)

        if ((filterIndex + 1) % 10 === 0) {
          this.rightCurrentPage = (filterIndex + 1) / 10 + 1
        }
      }
    },
    // 右侧穿梭框数据下移
    clickDown(id) {
      let filterIndex
      this.rightFilteredData.some((item, itemIndex) => {
        if (item.id === id) {
          filterIndex = itemIndex
          return true
        }
      })
      if (filterIndex === this.rightFilteredData.length - 1) {
        this.$message({
          type: 'error',
          message: '最后一条数据, 不能下移'
        })
      } else {
        // 后一条数据的的id
        let nextId = this.rightFilteredData[filterIndex + 1].id
        // 前一条数据在 this.value 中的位置
        let nextIndex = this.value.indexOf(nextId)
        // 当前需要下移的id
        let currentId = id
        // 当前需要下移的数据在 this.value 中的位置
        let currentIndex = this.value.indexOf(currentId)
        // 交换两条数据的位置
        this.$set(this.value, nextIndex, currentId)
        this.$set(this.value, currentIndex, nextId)
        // 移动数据位于该页最后一条，则下移之后，跳转至后一页
        if ((filterIndex + 1) % 10 === 0) {
          this.rightCurrentPage = (filterIndex + 1) / 10 + 1
        }
      }
    },
    handleCurrentChange(from, currentPage) {
      this[from + 'CurrentPage'] = currentPage
    },
    getShow(index, from) {
      let min = (this[from + 'CurrentPage'] - 1) * this[from + 'PageSize']
      let max = this[from + 'CurrentPage'] * this[from + 'PageSize']
      let num = index + 1
      let flag1 = min < num
      let flag2 = num <= max
      return flag1 && flag2
    },
    clickSearch(from) {
      this[from + 'CurrentPage'] = 1
      this[from + 'Search'] = this[from + 'Input']
    },
    checkboxChange(id, from, checkedValue) {
      if (checkedValue) {
        this[from + 'Checked'].push(id)
      } else {
        let index = this[from + 'Checked'].indexOf(id)
        if (index > -1) {
          this[from + 'Checked'].splice(index, 1)
        }
      }
    },
    clickToLeft(movetType) {
      if (movetType === 'some' && !this.rightChecked.length) {
        return this.$message({
          type: 'error',
          message: '请至少选择一本书刊'
        })
      }
      let currentValue = this.value.slice()
      this.data.forEach((item) => {
        if (this.rightChecked.indexOf(item.id) > -1) {
          item.checked = false
        }
      })
      movetType === 'some'
        ? this.rightChecked.forEach((item) => {
            const index = currentValue.indexOf(item)
            if (index > -1) {
              currentValue.splice(index, 1)
            }
          })
        : currentValue.splice(0, currentValue.length)
      this.value = currentValue
      this.$store.commit('config/UPDATE_BOOKSLIB_IDS', this.value)
      this.rightChecked = []
      this.$nextTick(() => {
        this.rightCurrentPage = this.$refs.rightPagination.$children[0].internalCurrentPage
      })
    },
    clickToRight(movetType) {
      if (movetType === 'some' && !this.leftChecked.length) {
        return this.$message({
          type: 'error',
          message: '请至少选择一本书刊'
        })
      }
      let currentValue = this.value.slice()
      const itemsToBeMoved = []
      const key = this.props.key
      this.data.forEach((item) => {
        const itemKey = item[key]
        const condition = movetType === 'some' ? this.leftChecked.indexOf(itemKey) > -1 : true
        if (condition && this.value.indexOf(itemKey) === -1) {
          item.checked = false
          itemsToBeMoved.push(itemKey)
        }
      })
      currentValue = this.targetOrder === 'unshift' ? itemsToBeMoved.concat(currentValue) : currentValue.concat(itemsToBeMoved)
      this.$store.commit('config/UPDATE_BOOKLIBTITLE_CHOSEBOOKLIST', JSON.parse(JSON.stringify(currentValue)))
      this.leftChecked = []
      this.$nextTick(() => {
        this.leftCurrentPage = this.$refs.leftPagination.$children[0].internalCurrentPage
      })
    },
    goDetail(id, readModel, url) {
      if (readModel == -2) {
        window.open(url, '_blank')
      } else {
        let curId = String(id)
        const encryption_id = setEncryption(curId.slice(5))
        if (curId.indexOf('ebook') > -1) {
          let routeUrl1 = this.$router.resolve({
            path: '/book',
            query: { id: encryption_id }
          })
          window.open(routeUrl1.href, '_blank')
        } else if (curId.indexOf('album') > -1) {
          let routeUrl2 = this.$router.resolve({
            path: '/bookshelfdetail',
            query: { id: encryption_id }
          })
          window.open(routeUrl2.href, '_blank')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lob {
  background-color: red;
}
.bookshelf-edit-transfer {
  margin: 20px 0 60px 0;
  // background: url('../assets/imgs/bg1.png');
  // background-size: cover;
  .bookshelf-xtransfer-content {
    // padding-left: 20px;
    display: flex;
    align-items: center;
  }
  .xtransfer-left {
    width: 460px;
    height: 534px;
    // border: 1px solid #fa6400;
  }
  .xtransfer-right {
    width: 505px;
    height: 534px;
    // border: 1px solid #fa6400;
    // .xtransfer-list {
    //   height: 314px !important;
    // }
    .xtransfer-main {
      // height: 386px !important;
      padding-top: 54px !important;
    }
  }
  .xtransfer-btn-group {
    width: 70px;
    display: flex;
    // flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .xtransfer-btn {
      width: 45px;
      height: 45px;
      cursor: pointer;
    }
    .xtransfer-btn-toleft {
      margin-top: 8px;
      background-image: url('../../assets/imgs/bookshelfedit/move_left.png');
      background-size: 100% 100%;
    }
    .xtransfer-btn-toright {
      margin-top: 8px;
      background-image: url('../../assets/imgs/bookshelfedit/move_right.png');
      background-size: 100% 100%;
    }
    .xtransfer-btn-torightall {
      background-image: url('../../assets/imgs/bookshelfedit/move_right_all.png');
      background-size: 100% 100%;
    }
    .xtransfer-btn-toleftall {
      margin-top: 8px;
      background-image: url('../../assets/imgs/bookshelfedit/move_left_all.png');
      background-size: 100% 100%;
    }
  }
  .xtransfer-header {
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    background: #df5813;
  }
  .xtransfer-main {
    height: 454px;
    padding-top: 20px;
    border: 1px solid #fa6400;
    background: #fff;
    .xtransfer-input {
      display: flex;
      width: 200px;
      margin-bottom: 15px;
      margin-left: 16px;
      label {
        width: 60px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        background: #df5813;
        cursor: pointer;
      }
      /deep/ .el-input {
        font-size: 14px !important;
      }
      /deep/ .el-input__inner {
        height: 26px !important;
        line-height: 26px !important;
        border-right: none !important;
        border-radius: 0 !important;
      }
    }
    .xtransfer-list {
      height: 280px;
      li {
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
        .item-info-time {
          margin-left: 15px;
          font-size: 14px;
          width: 120px;
        }
        .item-info-icon-line {
          cursor: pointer;
          width: 14px;
          height: 14px;
        }
        .item-info-icon {
          width: 18px;
          height: 18px;
          margin-left: 10px;
          cursor: pointer;
          &.info-icon-up {
            margin-left: 5px;
          }
          &.info-icon-down {
            margin-left: 3px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .xtransfer-nomatch {
      height: 280px;
      padding-right: 20px;
      line-height: 280px;
      text-align: center;
      font-size: 14px;
    }
  }
}
/deep/.el-checkbox__input {
  width: 16px;
  height: 16px;
  border: 1px solid #df5813;
  text-align: center;
  top: -3px;
  .el-checkbox__inner {
    top: 1px;
    width: 10px;
    height: 10px;
    border: none !important;
  }
  .el-checkbox__inner::after {
    display: none !important;
  }
}
/deep/ .el-checkbox__label {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 3px;
  font-size: 14px;
  line-height: 15px;
  color: #515151 !important;
}
/deep/ .el-pagination1 {
  justify-content: center;
  margin: 30px 0;
  padding-right: 25px;
  .el-pagination button,
  .el-pagination li {
    min-width: 25px !important;
  }
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    padding: 0 4px !important;
  }
  .el-pagination .btn-prev {
    margin-left: 0px !important;
  }
  .el-pagination--small .btn-prev,
  .el-pagination--small .btn-next,
  .el-pagination--small .el-pager li,
  .el-pagination--small .el-pager li.btn-quicknext,
  .el-pagination--small .el-pager li.btn-quickprev,
  .el-pagination--small .el-pager li:last-child {
    height: 24px !important;
    line-height: 24px !important;
  }
}
.xtransfer-tabs {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  div {
    display: inline-block;
    width: 140px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
    background: #fff;
    color: #df5813;
    border: 1px solid #df5813;
    &.active {
      background: #df5813;
      color: #fff;
    }
  }
}
</style>
